import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { LogSeverity, LoggingService } from '@core/services/logging.service';

@Injectable({
  providedIn: 'root',
})
export class DriveThruBffService {
  private currentStatus: any = null;

  constructor(private http: HttpClient, private logger: LoggingService) {}

  private async fetchStoreStatus() {
    if (!environment.driveThruBffUrl) {
      this.logger.consoleLog('Bff URL is missing!');
      this.logger.writeLog('Bff URL is missing!', {
        severity: LogSeverity.ERROR,
      });
      return;
    }

    const storeId = localStorage.getItem('storeId');

    try {
      const response = await this.http
        .get(`${environment.driveThruBffUrl}/laneStatus`, {
          params: new HttpParams().set('storeId', storeId !== null ? storeId : ''),
        })
        .toPromise();

      const parsedData: any = await response;
      this.currentStatus = parsedData.status;
      this.logger.writeLog(`Lane status: ${this.currentStatus}`, {
        severity: LogSeverity.INFO,
      });
    } catch (error) {
      this.logger.writeLog('Error fetching drive thru bff:', {
        error,
        severity: LogSeverity.ERROR,
      });
    }
  }

  async storeStatus() {
    const storeStatus = await this.checkStoreStatus();
    this.logger.consoleLog('storeStatus', storeStatus);
    return storeStatus;
  }

  async checkStoreStatus() {
    try {
      await this.fetchStoreStatus();
      return this.currentStatus;
    } catch (_error) {
      return 'CLOSED';
    }
  }
}
